webpackJsonp([188663379315634],{

/***/ 434:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"frontmatter":{"title":"Long Awaited Updates Part 4: R.A.C.H.E.L. Undying Launch, New Website Launch, and more Brandon Sanderson!","path":"/website-launch-rachel-undying-dnd-brandon-sanderson"}}}]}},"pathContext":{"tag":"D&D"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-d-d-ff71fc8d63be554b8756.js